<template>
  <b-container>
    <b-row class="ja-decoration">
    </b-row>
    <b-form @submit.prevent="reset()">
      <b-row class="d4d-login">
        <b-col cols="12">
          <b-col cols="12" class="mt-1 title">{{ $t("reset_password_title") }}</b-col>
          <b-col cols="12 mt-4">
            <ul class="mt-2 error-content">
              <li class="error-text" v-for="error in tokenErrors" v-bind:key="error">{{ error }}</li>
            </ul>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12 mt-4">
            <label for="password">{{ $t("reset_new_password") }}</label>
            <input id="password" type="password" v-model="form.password" value="">
            <span v-if="passwordError" class="form-error">{{ $t("error_required_field") }}</span>
            <ul class="error-content">
              <li class="error-text" v-for="error in passwordErrors" v-bind:key="error">{{ error }}</li>
            </ul>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12 mt-4">
            <label for="confirm-password">{{ $t('reset_confirm_new_password') }}</label>
            <input id="confirm-password" type="password" v-model="form.confirmPassword" value="">
            <span v-if="confirmPasswordError" class="form-error">{{ confirmPasswordError }}</span>
          </b-col>
        </b-col>
        <b-col cols="12">
          <b-col cols="12" class="mt-5">
            <b-button block variant="primary" type="submit">{{ $t('change_password_btn') }}</b-button>
          </b-col>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="mt-5">
      <b-col>
        <legal-message/>
      </b-col>
    </b-row>
    <b-modal id="modal-reset-password-success" no-close-on-backdrop centered hide-header hide-footer>
      <div class="children-privacy-protection">
        <div class="children-privacy-protection-header">
        </div>
        <div class="children-privacy-protection-body">
          <div class="alert alert-success" role="alert">
            {{ $t('reset_password_successfully') }}
          </div>
        </div>
        <div class="children-privacy-protection-button">
        </div>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { UserService } from '../Services';
import { Spinner } from '../../../core/Utils'
import LegalMessage from "../Components/LegalMessage"

export default {
  name: 'ResetPassword',
  components: { LegalMessage },
  data(){
    return {
      form: { token: "", email: "", password: "", confirmPassword: "" },
      passwordError: false,
      confirmPasswordError: "",
      passwordErrors: [],
      tokenErrors: [],
      serviceError: false
    }
  },
  methods: {
    reset(){
      const form = this.form;
      form.token = this.$route.query.token;
      form.email = this.$route.query.email;

      const password = form.password;
      const confirmPassword = form.confirmPassword;
      this.passwordError = password === "";

      if(confirmPassword === "")this.confirmPasswordError = "This field is required";
      if(password !== confirmPassword) this.confirmPasswordError =  "Must coincide with password";
      if(confirmPassword !== "" && password === confirmPassword) this.confirmPasswordError =  "";

      if(password && confirmPassword && password === confirmPassword) {
        Spinner.start()
        this.passwordErrors = []
        this.tokenErrors = []
        this.serviceError = false

        UserService.changePassword(form).then(() => {
          Spinner.stop();

          this.$bvModal.show('modal-reset-password-success');
          setTimeout(() => {
            this.$bvModal.hide('modal-reset-password-success');
            this.$router.push({name: 'Login'});
          }, 1500)
        }).catch(err => {
          Spinner.stop()
          this.serviceError = this.$t("error_unexpected")
          if (err) {
            if (err.message) {
              this.serviceError = err.message
            }
            if (err.errors && err.errors['Password']) {
              err.errors['Password'].forEach(error => this.passwordErrors.push(this.$t(error)))
            }

            if (err.errors && err.errors['InvalidToken']) {
              this.tokenErrors.push(this.$t("error_invalid_token"))
            }
          }
        })
      }
    }
  }
}

</script>
<style scoped lang="stylus">

@import "../Styles/security_styles.styl"

.children-privacy-protection-body
  .alert-success
    margin-top: 1rem;

</style>
